function validateFileNameNonEmpty(fileName) {
    return fileName != '';
}

function validateFileNameContainsNoSlash(fileName) {
    return fileName.indexOf('/') == -1;
}